export const guid = () => {
  return Math.random()
    .toString(36)
    .substring(2, 15);
};

export const fieldReorderByKey = (arr, key, toIndex) => {
  const index = arr.findIndex(i => i.key === key);
  if (index === -1) return;

  const item = arr[index];
  arr.splice(index, 1);
  arr.splice(toIndex, 0, item);
};
